import { Navigate } from "react-router-dom";
import { AuthApi } from "../lib/adminApi";

export default function RequireAdmin({ children }) {
    if (!AuthApi.hasToken()) return <Navigate to="/admin/login" replace />;
    return children;
}
